import React, { useMemo } from "react";
import { Tooltip } from "@blueprintjs/core";
import classNames from "classnames";
import AccuracyIndicator from "rs-components/AccuracyIndicator";
import Loader from "components/Loader";
import { ResultElementSourceAppearance } from "store/rs-workspace/rs-workspace.types";
import PauseIcon from "icons/icn-pause.svg";
import * as styles from "./styles.module.scss";
const alwaysVisibleAppearances = [
    ResultElementSourceAppearance.InProgress,
    ResultElementSourceAppearance.Paused,
];
const CalculationStatusIcon = ({ appearance, accuracy, hideAccuracy, className }) => {
    const statusIcon = useMemo(() => {
        switch (appearance) {
            case ResultElementSourceAppearance.InProgress:
                return (React.createElement(Tooltip, { content: "Calculation is in progress", minimal: true, openOnTargetFocus: false, placement: "left", popoverClassName: styles.tooltip },
                    React.createElement(Loader, { accented: true, size: 20 })));
            case ResultElementSourceAppearance.Paused:
                return (React.createElement(Tooltip, { content: "Calculation is paused", minimal: true, openOnTargetFocus: false, placement: "left", popoverClassName: styles.tooltip },
                    React.createElement(PauseIcon, { className: styles["pause-icon"] }),
                    ";"));
            default:
                return hideAccuracy ? null : (React.createElement(AccuracyIndicator, { calculatedAccuracy: accuracy, tooltipDisabled: !accuracy }));
        }
    }, [accuracy, appearance, hideAccuracy]);
    return !alwaysVisibleAppearances.includes(appearance) && hideAccuracy ? null : (React.createElement("div", { className: classNames(styles["status-icon"], className) }, statusIcon));
};
export default CalculationStatusIcon;
